/**
 * @flow
 * @relayHash 9d4773ca0ac1a6e577b1b853cdb8bb21
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeliveryLocationCodeTypes = "CONCIERGE" | "INVALID" | "MAILBOX" | "OTHER_OPTION" | "OTHER_RECIPIENT" | "RECIPIENT" | "%future added value";
export type deliveryNotReceivedContextQueryVariables = {|
  pdcbr_uuid: string
|};
export type deliveryNotReceivedContextQueryResponse = {|
  +deliveryNotReceivedContext: ?{|
    +recipientInfo: ?{|
      +firstName: ?string,
      +lastName: ?string,
      +originalPhone: ?string,
      +subscribedPhone: ?string,
    |},
    +receivedBy: ?string,
    +shouldConfirmPackageDelivery: ?boolean,
    +locationCode: ?DeliveryLocationCodeTypes,
    +recipientRelationship: ?string,
    +enableComplementaryDeliveryInfoLayout: ?boolean,
  |}
|};
export type deliveryNotReceivedContextQuery = {|
  variables: deliveryNotReceivedContextQueryVariables,
  response: deliveryNotReceivedContextQueryResponse,
|};
*/

/*
query deliveryNotReceivedContextQuery(
  $pdcbr_uuid: String!
) {
  deliveryNotReceivedContext(pdcbrUuid: $pdcbr_uuid) {
    recipientInfo {
      firstName
      lastName
      originalPhone
      subscribedPhone
    }
    receivedBy
    shouldConfirmPackageDelivery
    locationCode
    recipientRelationship
    enableComplementaryDeliveryInfoLayout
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'pdcbr_uuid',
        type: 'String!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'deliveryNotReceivedContext',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'pdcbrUuid',
            variableName: 'pdcbr_uuid'
          }
        ],
        concreteType: 'DeliveryNotReceivedContextNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'recipientInfo',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerRecipientInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'firstName',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'lastName',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'originalPhone',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'subscribedPhone',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'receivedBy',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'shouldConfirmPackageDelivery',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'locationCode',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'recipientRelationship',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'enableComplementaryDeliveryInfoLayout',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'deliveryNotReceivedContextQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'deliveryNotReceivedContextQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'deliveryNotReceivedContextQuery',
      id: null,
      text:
        'query deliveryNotReceivedContextQuery(\n  $pdcbr_uuid: String!\n) {\n  deliveryNotReceivedContext(pdcbrUuid: $pdcbr_uuid) {\n    recipientInfo {\n      firstName\n      lastName\n      originalPhone\n      subscribedPhone\n    }\n    receivedBy\n    shouldConfirmPackageDelivery\n    locationCode\n    recipientRelationship\n    enableComplementaryDeliveryInfoLayout\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'a8552220d03eed18a78a4e192194c8cd';
module.exports = node;
